/**
 * src下增加features目录，提供定制化功能统一管理
 * 以微盘相关功能为例(B端新增功能，C端不支持)
 * B端提供功能调用接口，C端mock空包
 */
export default class WedriveFileManager {
    public static getInstance(): any {
        return null;
    }

    public static setWedriveAction(actionMap: Map<string, (...args: any[]) => any>) {

    }
}

